import type { ConfirmFuncProps } from "./_type";

import { createElement, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { App } from "antd";

import { AntdIcon } from "./icon";
import { useAppContext } from "./provider";

import { CONFIRM_CONFIG_MAPPER } from "~/common/constants";

/**
 * Antd App Provider - hook
 */
export const useApp = () => {
  /** useApp */
  const { modal, message, notification } = App.useApp();
  /** useAppContext */
  const { askAgain } = useAppContext();
  /** i18n */
  const { t } = useTranslation("common");

  /** confirm */
  const confirm = useCallback(
    (props: ConfirmFuncProps) => {
      if (askAgain[props.theme]) {
        const { title, content } = CONFIRM_CONFIG_MAPPER[props.theme];
        modal.confirm({
          width: 500,
          icon: createElement(AntdIcon, { name: "ExclamationCircleOutlined" }),
          title: createElement("span", {
            dangerouslySetInnerHTML: { __html: t(title) },
          }),
          content: createElement("span", {
            dangerouslySetInnerHTML: { __html: t(content) },
          }),
          ...props,
        });
      } else {
        props?.onOk?.(askAgain[props.theme]);
      }
    },
    [modal, t, askAgain]
  );

  /** return */
  return useMemo(
    () => ({ modal, message, notification, confirm }),
    [confirm, message, modal, notification]
  );
};
